import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const etapes = [
  "Visite technique à domicile pour mesurer et analyser le volet",
  "Choix du moteur Somfy adapté au poids, à la largeur et au type de tablier",
  "Installation du moteur tubulaire dans l'axe du volet sans dégradation",
  "Pose des points de commande : interrupteur, télécommande ou commande connectée",
  "Programmation des fins de course et paramétrage des commandes io ou RTS",
  "Tests complets et démonstration du fonctionnement à l'utilisateur",
];

export default function CommentCaSePasse() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative rounded-xl overflow-hidden border border-brand-border">
            <ImagePlaceholder src="https://readdy.ai/api/search-image?query=Professional%20technician%20in%20a%20blue%20uniform%20installing%20a%20Somfy%20motor%20inside%20a%20roller%20shutter%20box%20during%20a%20motorization%20project%20in%20a%20French%20home%20near%20Strasbourg%20clean%20work%20environment%20natural%20daylight%20professional%20service%20photography%20warm%20tones&width=700&height=520&seq=moto-comm&orientation=landscape" alt="Technicien installant un moteur Somfy lors d'une motorisation à Strasbourg" className="w-full h-[340px] md:h-[420px]" loading="lazy" width={700} height={520} />
          </div>

          <div>
            <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold mb-5">
              Comment se passe la <strong className="text-brand-blue">motorisation Somfy</strong>
            </h2>
            <p className="text-brand-text text-base leading-relaxed mb-5">
              La motorisation d'un volet roulant avec Somfy commence par une <strong className="text-brand-blue">visite technique à domicile</strong>. Nos techniciens mesurent la baie, analysent le type de tablier et évaluent l'espace disponible dans le coffre. Nous calculons le couple nécessaire en fonction du poids du volet, de sa largeur et du matériau des lames. Ce diagnostic initial garantit le choix du moteur parfaitement adapté à votre installation.
            </p>
            <p className="text-brand-text text-base leading-relaxed mb-6">
              L'installation proprement dite se déroule en une à deux heures par volet. Le <strong className="text-brand-blue">moteur tubulaire Somfy</strong> est inséré dans l'axe du volet, les commandes sont posées et câblées selon le protocole choisi (filaire, RTS ou io). Nous réglons les fins de course, programmons les télécommandes et testons chaque fonction. Vous repartez avec un volet entièrement motorisé, prêt à être piloté à distance ou programmé automatiquement.
            </p>
            <ul className="space-y-3">
              {etapes.map((etape) => (
                <li key={etape} className="flex items-start gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-brand-cyan/10 shrink-0 mt-0.5">
                    <i className="ri-check-line text-brand-cyan text-sm"></i>
                  </span>
                  <span className="text-brand-text text-base">{etape}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}